import angular from 'angular';
import display from './builder/display.html';
import validate from './builder/validate.html';
import api from './builder/api.html';

angular.module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/repre/display.html', display);
	$templateCache.put('kform/components/repre/validate.html', validate);
	$templateCache.put('kform/components/repre/api.html', api);
});
